<div id="common-frame" *ngIf="openIdProfile">
    <h2>
        {{ headingLabel }}
        <span *ngIf="tgtOpenIdProfile">{{ tgtOpenIdProfile.email }}</span>
    </h2>

    <p *ngIf="transactionModel">
        Transaction #{{ transactionModel.id }}<br />
        Amount {{ transactionModel.amount | currency }}
    </p>

    <form [formGroup]="formGroup" (ngOnSubmit)="validate()">
        <div *ngIf="elements.receiverEmail">
            <label>Receiver Email:</label>
            <input
                [required]="elements.receiverEmail"
                formControlName="receiverEmail"
                class="form-control form-control-sm"
                type="text"
            />
        </div>

        <div *ngIf="elements.amount">
            <label>Amount:</label>
            <input
                [required]="elements.amount"
                formControlName="amount"
                class="form-control form-control-sm"
                type="number"
            />
        </div>

        <div *ngIf="elements.referenceId">
            <label>Reference ID:</label>
            <input
                [required]="elements.referenceId"
                formControlName="referenceId"
                class="form-control form-control-sm"
                type="text"
            />
        </div>

        <div *ngIf="elements.comment">
            <label>Comment:</label>
            <textarea
                [required]="elements.comment"
                formControlName="comment"
                class="form-control form-control-sm"
            ></textarea>
        </div>
    </form>

    <div
        *ngIf="message"
        [ngClass]="{
            'alert alert-success': true,
            'alert-danger': !success
        }"
    >
        {{ message }}
    </div>
</div>

<div class="grid-split-2">
    <div>
        <button
            *ngIf="!processing"
            class="btn btn-sm btn-primary"
            (click)="validate()"
        >
            {{ submitLabel }}
        </button>

        <button *ngIf="processing" class="btn btn-sm btn-primary">
            <span class="spinner-border spinner-border-sm"></span>
            Processing...
        </button>
    </div>
    <div>
        <button
            (click)="cancel()"
            *ngIf="dialogContext && !processing"
            class="btn btn-sm btn-warning"
        >
            <span *ngIf="!actionComplete">Cancel</span>
            <span *ngIf="actionComplete">Close</span>
        </button>
    </div>
</div>
